import fi from "./fi";
import se from './se';

let dateTimeFormat = {
    date: { year: "numeric", month: "long", day: "numeric", hour12: false },
    time: { hour: "numeric", minute: "numeric", second: "numeric", hour12: false },
    full: {
        year: "numeric", month: "long", day: "numeric",
        hour: "numeric", minute: "numeric", second: "numeric", hour12: false
    }
};

let numberFormat = {
    currency: { style: "currency", currency: "EUR" }
};

export default {
    enabledLocales: [ "fi", "se" ],
    messages: { fi, se },
    dateTimeFormats: {
        fi: dateTimeFormat,
        se: dateTimeFormat,
    },
    numberFormats: {
        fi: numberFormat,
        se: numberFormat,
    },
} as any;